import { createTheme } from "@mui/material/styles";

import { colors } from "../overrides/colors";
import { palette } from "../overrides/palette";
import { typograhpy } from "../overrides/typography";

export const theme = createTheme({
  palette: palette,
  typography: typograhpy,
  spacing: 5,
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: "150px", textTransform: "initial" },
      },
      defaultProps: {
        color: "primary",
        variant: "contained",
        disableElevation: true,
      },
    },
    MuiFab: {
      styleOverrides: {
        root: { boxShadow: "0px 12px 22px rgba(120, 39, 212, 0.1)" },
        sizeSmall: { boxShadow: "none" },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 10px 30px rgba(11, 27, 38, 0.05)",
          border: "none",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "@global": {
          html: {
            WebkitFontSmoothing: "auto",
          },
          body: {
            backgroundColor: colors.light,
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "#F5F7FC",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paperAnchorDockedLeft: {
          borderRight: "none",
          elevation: 0,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: colors.grey,
          fontWeight: 600,
          fontSize: 14,
          lineHeight: 1.6428571429, // centers the label in textfield for 14px font size, equal to 23px
          letterSpacing: -0.5,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          "&:focus": {
            backgroundColor: "none",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: "white",
          boxShadow: "none",
          borderRadius: 0,
        },
        notchedOutline: {
          borderColor: "#EDF0F5",
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: "outlined" },
    },
  },
});
